<div id="container">

</div>

<svg>
  <filter id="noiseFilter">
    <feTurbulence type="fractalNoise" baseFrequency="20" result="noisy" />
    <feBlend in="SourceGraphic" in2="noisy" mode="multiply" result="noised" />
    <feGaussianBlur in="noised" stdDeviation=".02,0" />
  </filter>
</svg>
